import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setAccessToken, getAccessToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, object=auth

  const loadMe = async () => {
    try {
      const { data } = await api.get("/api/auth/me");
      setUser(data.user);
      return data.user;
    } catch (e) {
      setUser(null);
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      if (getAccessToken()) {
        await loadMe();
      } else {
        // Try silent refresh (httpOnly cookie) then load profile.
        try {
          const { data } = await api.post("/api/auth/refresh");
          setAccessToken(data.access_token);
          await loadMe();
        } catch (e) {
          setUser(null);
        }
      }
    })();
  }, []);

  const login = async (payload) => {
    const { data } = await api.post("/api/auth/login", payload);
    setAccessToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/api/auth/register", payload);
    setAccessToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/api/auth/logout");
    } catch (e) {}
    setAccessToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
